import styled from 'theme';

export const TermsCheckboxLabel = styled.span`
  font-size: 0.75rem;
  font-weight: ${props => props.theme.variables.fonts.weight.light};
  color: ${props => props.theme.variables.colors.darkGrey};

  a {
    font-weight: ${props => props.theme.variables.fonts.weight.regular};

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const RegistrationFooter = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: flex-end;

  > * {
    margin-left: 0.5rem;
  }
`;

export const FieldWithTooltip = styled.div<{ type?: string }>`
  position: relative;
  display: flex;

  img {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1.5rem;
    height: 1.5rem;
    ${props => (props.type === 'textarea' ? `top: 40%` : ``)}
  }

  .textarea__content textarea,
  .input__content input {
    padding-right: 3rem;
  }

  > div:last-child {
    z-index: 1;
  }
`;

export const RegistrationTooltip = styled.div`
  max-width: 15rem;
  line-height: 1.3;
`;

export const UploadTestCert = styled.div`
  display: flex;
  align-items: flex-start;

  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.2rem;
    margin-top: 0.2rem;
    right: -0.2rem;
    position: relative;
  }
`;
